export default blogs => {
    return [...new Set(Object.values(blogs.lookup).reduce((acc, item) => {
        if (!Array.isArray(item.tags)) return acc;

        return acc.concat(item.tags);
    }, []))];
};  